import * as React from 'react';
import {Button} from '@mui/material';
import Spinner from '../Spinner';
import Row from '../Row';

const FormButton = ({children,working = false, onSubmit,...props}) => {
    const propsFunc = (onSubmit) ? onSubmit : null;

    return (
        <Row>
			<Button
				type="submit"
				variant="contained"
				disabled={working}
				onClick={propsFunc}
				{...props}
			>{children}</Button>
			{working && <Spinner />}
		</Row>
	);
};
export default FormButton;
